import React from "react";
import PropTypes from "prop-types";
import {ChromePicker, GithubPicker} from "react-color";
import withErrorBoundary from "../decorators/withErrorBoundary";
import trackEvent from "../../../utils/track-event";

class ColorPicker extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    onChange: PropTypes.func,
    children: PropTypes.element,
    position: PropTypes.string,
    withoutTransparent: PropTypes.bool,
    content: PropTypes.element
  };
  static defaultProps = {
    position: `bottom-right`,
    withoutTransparent: false
  };
  state = {
    isOpenPicker: false,
    pickerType: `Популярные`
  };
  componentDidMount() {
    document.addEventListener(`mousedown`, this.togglePicker.bind(this));
  }
  componentWillUnmount() {
    document.removeEventListener(`mousedown`, this.togglePicker.bind(this));
  }
  togglePicker = (e) => {
    const paletteNode = this.palette.current;
    const contentNode = this.content.current;
    if (paletteNode && !contentNode) {
      this.setState({
        isOpenPicker: paletteNode.contains(e.target)
          ? !this.state.isOpenPicker
          : false
      });
    } else if (paletteNode && contentNode) {
      this.setState({
        isOpenPicker: paletteNode.contains(e.target)
          ? !this.state.isOpenPicker
          : contentNode.contains(e.target)
      });
    }
  };
  setPickerType = (type) => () => {
    this.setState({
      pickerType: type
    });
    if (type === `Палитра`) {
      trackEvent({
        category: `Editor`,
        action: `Palette`
      });
    }
  };
  onChangeCirclePicker = (e) => {
    this.props.onChange(e, `circle`);
  };
  onChangeChromePicker = (e) => {
    this.props.onChange(e, `palette`);
  };
  getPicker() {
    const {pickerType} = this.state;
    const {color} = this.props;
    switch (pickerType) {
      case `Популярные`:
        return (
          <GithubPicker
            color={color}
            onSwatchHover={this.onChangeCirclePicker}
            onChangeComplete={(e) => {
              this.onChangeCirclePicker(e);
              this.togglePicker(e);
            }}
            colors={[
              `rgb(0,0,0)`,
              `rgb(80,0,255)`,
              `rgb(4,16,160)`,
              `rgb(33,165,42)`,
              `rgb(255,102,0)`,

              `rgb(102,102,102)`,
              `rgb(117,34,189)`,
              `rgb(0,0,255)`,
              `rgb(0,255,0)`,
              `rgb(255,153,153)`,

              `rgb(128,128,128)`,
              `rgb(169,51,204)`,
              `rgb(0,108,255)`,
              `rgb(199,255,92)`,
              `rgb(255,98,98)`,

              `rgb(170,180,180)`,
              `rgb(217,112,255)`,
              `rgb(11,173,255)`,
              `rgb(255,255,153)`,
              `rgb(198,0,82)`,

              `rgb(255,255,255)`,
              `rgb(174,111,255)`,
              `rgb(167,209,255)`,
              `rgb(255,213,0)`,
              `rgb(109,0,62)`,

              `transparent`,
              `rgb(197,172,255)`,
              `rgb(0,255,255)`,
              `rgb(255,255,0)`,
              `rgb(255,0,0)`
            ]}
          />
        );
      case `Палитра`:
        return (
          <ChromePicker
            color={color}
            onChangeComplete={this.onChangeChromePicker}
          />
        );
    }
    return void 0;
  }
  palette = React.createRef();
  content = React.createRef();
  render() {
    const {color, children, position, content} = this.props;
    const {isOpenPicker, pickerType} = this.state;
    return (
      <div
        className={`color-picker${children ? `` : ` color-picker_transparent`}`}
      >
        {children ? (
          <div className="color-picker__palette" ref={this.palette}>
            {children}
          </div>
        ) : (
          <div
            className="color-picker__palette"
            ref={this.palette}
            style={{
              width: `100%`,
              height: `100%`,
              borderRadius: `inherit`,
              backgroundColor: color
            }}
          />
        )}
        {isOpenPicker && (
          <div
            ref={this.content}
            className={`color-picker__content color-picker__content_${position}`}
          >
            <div className="color-picker__header">
              {content ? content : null}
              {[`Популярные`, `Палитра`].map((item) => {
                return (
                  <span
                    key={item}
                    className={`color-picker__item${
                      pickerType === item ? ` color-picker__item_active` : ``
                    }`}
                    onClick={this.setPickerType(item)}
                  >
                    {item}
                  </span>
                );
              })}
            </div>
            <div className="color-picker__body">{this.getPicker()}</div>
          </div>
        )}
      </div>
    );
  }
}

export default withErrorBoundary(ColorPicker);
